import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'title',
    templateUrl: './title.component.html',
    styleUrls: ['./title.component.scss'],
    standalone: false
})
export class TitleComponent implements OnInit {
  @Input() direction: string = 'left';
  // pass style object ass input to the component as <title [style]="{'color': 'red'}">
  @Input() style: any = {};
  constructor() {}

  ngOnInit() {}
}
